/**
 * api.js — cliente axios del módulo Intervenciones.
 * Prefijo: /api/citas-tecnicas
 */

import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';
const PREFIJO = '/api/citas-tecnicas';

function getToken() {
  return localStorage.getItem('token');
}
function authHeaders() {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

// --- Dashboard (Fase 5) ---
export async function getDashboard() {
  const res = await axios.get(`${API_URL}${PREFIJO}/dashboard`, { headers: authHeaders() });
  return res.data;
}

// --- Disponibilidad personal para el sidebar (Fase 5b) ---
export async function getMiDisponibilidad() {
  const res = await axios.get(`${API_URL}${PREFIJO}/mi-disponibilidad`, { headers: authHeaders() });
  return res.data;
}

// --- Notificaciones (Fase 3) ---
export async function getMisNotificaciones(params = {}) {
  const res = await axios.get(`${API_URL}${PREFIJO}/notificaciones`, { params, headers: authHeaders() });
  return res.data;
}
export async function getNoLeidasCount() {
  const res = await axios.get(`${API_URL}${PREFIJO}/notificaciones/no-leidas-count`, { headers: authHeaders() });
  return res.data;
}
export async function marcarNotifLeida(id) {
  const res = await axios.post(`${API_URL}${PREFIJO}/notificaciones/${id}/leida`, {}, { headers: authHeaders() });
  return res.data;
}
export async function marcarTodasLeidas() {
  const res = await axios.post(`${API_URL}${PREFIJO}/notificaciones/leer-todas`, {}, { headers: authHeaders() });
  return res.data;
}
export async function getPreferenciasNotif() {
  const res = await axios.get(`${API_URL}${PREFIJO}/notificaciones/preferencias`, { headers: authHeaders() });
  return res.data;
}
export async function actualizarPreferenciasNotif(cambios) {
  const res = await axios.put(`${API_URL}${PREFIJO}/notificaciones/preferencias`, { cambios }, { headers: authHeaders() });
  return res.data;
}
export async function getPlantillasNotif() {
  const res = await axios.get(`${API_URL}${PREFIJO}/notificaciones/plantillas`, { headers: authHeaders() });
  return res.data;
}
export async function editarPlantillaNotif(id, payload) {
  const res = await axios.put(`${API_URL}${PREFIJO}/notificaciones/plantillas/${id}`, payload, { headers: authHeaders() });
  return res.data;
}

// --- Calendario + Informes (Fase 7) ---
export async function getCalendario(params = {}) {
  const res = await axios.get(`${API_URL}${PREFIJO}/calendario`, { params, headers: authHeaders() });
  return res.data;
}
export async function getResumenInformes(params = {}) {
  const res = await axios.get(`${API_URL}${PREFIJO}/informes/resumen`, { params, headers: authHeaders() });
  return res.data;
}
/**
 * Descarga el Excel (.xlsx) de citas vía fetch + blob (no requiere token en URL).
 */
export async function descargarCsvInformes(params = {}) {
  const q = new URLSearchParams(params).toString();
  const res = await axios.get(`${API_URL}${PREFIJO}/informes/export?${q}`, {
    headers: authHeaders(),
    responseType: 'blob',
  });
  const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = extractFilename(res.headers['content-disposition']) || 'intervenciones.xlsx';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => window.URL.revokeObjectURL(url), 1000);
}
function extractFilename(cd) {
  if (!cd) return null;
  const m = /filename="([^"]+)"/.exec(cd);
  return m ? m[1] : null;
}

// --- Campañas (admin) ---

export async function getCampanas(params = {}) {
  const res = await axios.get(`${API_URL}${PREFIJO}/campanas`, { params, headers: authHeaders() });
  return res.data;
}
export async function getCampanaById(id) {
  const res = await axios.get(`${API_URL}${PREFIJO}/campanas/${id}`, { headers: authHeaders() });
  return res.data;
}
export async function createCampana(payload) {
  const res = await axios.post(`${API_URL}${PREFIJO}/campanas`, payload, { headers: authHeaders() });
  return res.data;
}
export async function updateCampana(id, payload) {
  const res = await axios.put(`${API_URL}${PREFIJO}/campanas/${id}`, payload, { headers: authHeaders() });
  return res.data;
}
export async function deleteCampana(id) {
  const res = await axios.delete(`${API_URL}${PREFIJO}/campanas/${id}`, { headers: authHeaders() });
  return res.data;
}
/**
 * Cambia el estado de una campaña.
 * Retrocompatible: acepta un string (`cambiarEstadoCampana(id, 'Activa')`)
 * o un objeto (`cambiarEstadoCampana(id, { estado, revivir_participaciones })`).
 * Devuelve el objeto raw de la respuesta ({ id, estado, aviso, participaciones_revividas }).
 */
export async function cambiarEstadoCampana(id, estadoOrOpts) {
  const opts = typeof estadoOrOpts === 'string' ? { estado: estadoOrOpts } : (estadoOrOpts || {});
  const body = { estado: opts.estado };
  if (typeof opts.revivir_participaciones === 'boolean') {
    body.revivir_participaciones = opts.revivir_participaciones;
  }
  const res = await axios.put(
    `${API_URL}${PREFIJO}/campanas/${id}/estado`,
    body,
    { headers: authHeaders() }
  );
  return res.data;
}
/** Fase 13 (Opción C) — cuenta participaciones canceladas por el sistema. */
export async function contarParticipacionesCanceladasSistema(id) {
  const res = await axios.get(
    `${API_URL}${PREFIJO}/campanas/${id}/participaciones-canceladas-sistema`,
    { headers: authHeaders() }
  );
  return res.data.data; // { count: N }
}
export async function previewCapacidad(payload) {
  const res = await axios.post(`${API_URL}${PREFIJO}/campanas/preview-capacidad`, payload, { headers: authHeaders() });
  return res.data;
}
export async function previewImpacto(id, payload) {
  const res = await axios.post(`${API_URL}${PREFIJO}/campanas/${id}/preview-impacto`, payload, { headers: authHeaders() });
  return res.data;
}

// --- Condiciones de una cita (Fase 14b · #12) ---
export async function getCondicionesCita(citaId) {
  const res = await axios.get(
    `${API_URL}${PREFIJO}/mis-citas/${citaId}/condiciones`,
    { headers: authHeaders() }
  );
  return res.data.data; // { max_cancelaciones, cancelaciones_usadas, ..., puede_cancelar, ... }
}

// --- Resumen de campaña (Fase 4) ---
// `filtros`: { lote_id, empresa_id | empresa_colaboradora_id, negocio_id, departamento, estado }.
// Los vacíos no se envían. El servidor responde 400 a un filtro que no entiende.
function soloConValor(filtros = {}) {
  return Object.fromEntries(Object.entries(filtros).filter(([, v]) => v !== undefined && v !== null && v !== ''));
}
export async function getResumenCampana(id, filtros = {}) {
  const res = await axios.get(`${API_URL}${PREFIJO}/campanas/${id}/resumen`, {
    params: soloConValor(filtros), headers: authHeaders(),
  });
  return res.data;
}
/**
 * El historial de citas técnicas de UNA persona (pestaña de su ficha). `ambito`: 'interno' o
 * 'colaborador' — los ids de internas y colaboradoras se solapan, así que sin él no hay persona.
 */
export async function getHistorialPersona(ambito, id) {
  const res = await axios.get(`${API_URL}${PREFIJO}/personas/${encodeURIComponent(ambito)}/${encodeURIComponent(id)}/historial`, {
    headers: authHeaders(),
  });
  return res.data;
}
/**
 * Intervenciones sin cita (24/10). `datos`: { modalidad, fecha, nota?, tecnico_id? (gestión),
 * cita_id? (para marcar la cita viva que devolvió un 409 CITA_VIVA) }.
 */
const rutaIntervencion = (campanaId, personaId, tecnico = false) =>
  `${API_URL}${PREFIJO}${tecnico ? '/tecnico' : ''}/campanas/${encodeURIComponent(campanaId)}/participantes/${encodeURIComponent(personaId)}/intervencion`;
export async function registrarIntervencion(campanaId, personaId, datos) {
  const res = await axios.post(rutaIntervencion(campanaId, personaId), datos, { headers: authHeaders() });
  return res.data;
}
export async function deshacerIntervencion(campanaId, personaId) {
  const res = await axios.delete(rutaIntervencion(campanaId, personaId), { headers: authHeaders() });
  return res.data;
}
/**
 * A quién se puede añadir a la campaña al registrar su intervención (≥3 letras, ≤20; sólo nombre y
 * empresa/negocio). Gestión, o el técnico de ESA campaña.
 */
export async function getCandidatosIntervencion(campanaId, q) {
  const res = await axios.get(`${API_URL}${PREFIJO}/campanas/${encodeURIComponent(campanaId)}/candidatos-intervencion`, { params: { q }, headers: authHeaders() });
  return res.data.candidatos || [];
}
export async function getCandidatosTecnico(campanaId, q) {
  const res = await axios.get(`${API_URL}${PREFIJO}/tecnico/campanas/${encodeURIComponent(campanaId)}/candidatos`, { params: { q }, headers: authHeaders() });
  return res.data.candidatos || [];
}
/** Panel del técnico: los participantes de una campaña SUYA, y lo que puede deshacer. */
export async function getParticipantesTecnico(campanaId) {
  const res = await axios.get(`${API_URL}${PREFIJO}/tecnico/campanas/${encodeURIComponent(campanaId)}/participantes`, { headers: authHeaders() });
  return res.data;
}
export async function registrarIntervencionTecnico(campanaId, personaId, datos) {
  const res = await axios.post(rutaIntervencion(campanaId, personaId, true), datos, { headers: authHeaders() });
  return res.data;
}
export async function deshacerIntervencionTecnico(campanaId, personaId) {
  const res = await axios.delete(rutaIntervencion(campanaId, personaId, true), { headers: authHeaders() });
  return res.data;
}
/** CSV de participantes con los MISMOS filtros que el resumen. */
export async function descargarCsvResumen(id, filtros = {}) {
  const res = await axios.get(`${API_URL}${PREFIJO}/campanas/${id}/resumen/export`, {
    params: soloConValor(filtros), headers: authHeaders(), responseType: 'blob',
  });
  const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = extractFilename(res.headers['content-disposition']) || `campana-${id}-participantes.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => window.URL.revokeObjectURL(url), 1000);
}

// --- Lotes de campaña ---
export async function getLotes(campanaId) {
  const res = await axios.get(`${API_URL}${PREFIJO}/campanas/${campanaId}/lotes`, { headers: authHeaders() });
  return res.data.data;
}
/** criterio: { tipo: 'negocio'|'departamento'|'empresa'|'empresa_colaboradora'|'manual', valores: [...] } */
export async function previsualizarLote(campanaId, criterio) {
  const res = await axios.post(`${API_URL}${PREFIJO}/campanas/${campanaId}/lotes/previsualizar`, { criterio }, { headers: authHeaders() });
  return res.data;
}
/** persona_ids: las que el usuario confirmó en la previsualización. */
export async function crearLote(campanaId, { nombre, criterio, persona_ids }) {
  const res = await axios.post(`${API_URL}${PREFIJO}/campanas/${campanaId}/lotes`, { nombre, criterio, persona_ids }, { headers: authHeaders() });
  return res.data;
}
// Editar las personas de un lote (la única puerta con la campaña en curso).
export async function anadirAlLote(campanaId, loteId, persona_ids) {
  const res = await axios.post(`${API_URL}${PREFIJO}/campanas/${campanaId}/lotes/${loteId}/participantes`, { persona_ids }, { headers: authHeaders() });
  return res.data;
}
/** Sin confirmar, si alguna tiene cita viva responde 409 con `impacto.citas_a_cancelar`. */
export async function quitarDelLote(campanaId, loteId, persona_ids, confirmar_impacto = false) {
  const res = await axios.post(`${API_URL}${PREFIJO}/campanas/${campanaId}/lotes/${loteId}/participantes/quitar`, { persona_ids, confirmar_impacto }, { headers: authHeaders() });
  return res.data;
}
export async function moverEntreLotes(campanaId, loteId, persona_ids, lote_destino_id) {
  const res = await axios.post(`${API_URL}${PREFIJO}/campanas/${campanaId}/lotes/${loteId}/participantes/mover`, { persona_ids, lote_destino_id }, { headers: authHeaders() });
  return res.data;
}
export async function renombrarLote(campanaId, loteId, nombre) {
  const res = await axios.patch(`${API_URL}${PREFIJO}/campanas/${campanaId}/lotes/${loteId}`, { nombre }, { headers: authHeaders() });
  return res.data;
}
// Volver a avisar a quien sigue sin cita en un lote (una vez al día por lote).
/** A quién iría, a quién no y por qué (`bloqueo` si ahora no se puede), y los envíos anteriores. */
export async function previsualizarRecordatorioLote(campanaId, loteId) {
  const res = await axios.get(`${API_URL}${PREFIJO}/campanas/${campanaId}/lotes/${loteId}/recordatorio/previsualizar`, { headers: authHeaders() });
  return res.data;
}
/** Envía. Devuelve `totales` (destinatarios, enviados, fallidos, silenciados, ya_avisados_hoy) y `fallidas`. */
export async function reavisarLote(campanaId, loteId) {
  const res = await axios.post(`${API_URL}${PREFIJO}/campanas/${campanaId}/lotes/${loteId}/recordatorio`, {}, { headers: authHeaders() });
  return res.data;
}
/** Razones sociales (empresa contratante de internas), con «Sin empresa» al final si la hay. */
export async function getEmpresasContratantes() {
  const res = await axios.get(`${API_URL}${PREFIJO}/empresas-contratantes`, { headers: authHeaders() });
  return res.data;
}
export async function cancelarCitaAdmin(campanaId, citaId, motivo) {
  const res = await axios.post(
    `${API_URL}${PREFIJO}/campanas/${campanaId}/citas/${citaId}/cancelar-admin`,
    { motivo: motivo || null },
    { headers: authHeaders() }
  );
  return res.data;
}

// --- Personas (admin) ---

export async function getPersonasElegibles(params = {}) {
  const res = await axios.get(`${API_URL}${PREFIJO}/personas-elegibles`, { params, headers: authHeaders() });
  return res.data;
}
export async function getNegocios() {
  const res = await axios.get(`${API_URL}${PREFIJO}/negocios`, { headers: authHeaders() });
  return res.data;
}
export async function getDepartamentos(params = {}) {
  const res = await axios.get(`${API_URL}${PREFIJO}/departamentos`, { params, headers: authHeaders() });
  return res.data;
}
/** NUEVO: empresas colaboradoras para el selector en campañas de colaboradores */
export async function getEmpresasColaboradoras() {
  const res = await axios.get(`${API_URL}${PREFIJO}/empresas-colaboradoras`, { headers: authHeaders() });
  return res.data;
}

// --- Usuario final (Fase 3a) ---

export async function getMisCampanas() {
  const res = await axios.get(`${API_URL}${PREFIJO}/mis-campanas`, { headers: authHeaders() });
  return res.data;
}
export async function getMisCampanasPendientes() {
  const res = await axios.get(`${API_URL}${PREFIJO}/mis-campanas-pendientes`, { headers: authHeaders() });
  return res.data;
}
// Detalle self-scoped de una campaña para el flujo de reserva del usuario
// (NO usar getCampanaById aquí: ese es admin, requiere campanas.view).
export async function getMiCampana(campanaId) {
  const res = await axios.get(`${API_URL}${PREFIJO}/mis-campanas/${campanaId}`, { headers: authHeaders() });
  return res.data;
}
export async function getTecnicosDisponibles(campanaId) {
  const res = await axios.get(`${API_URL}${PREFIJO}/campanas/${campanaId}/tecnicos-disponibles`, { headers: authHeaders() });
  return res.data;
}
export async function getSlots(campanaId, params = {}) {
  const res = await axios.get(`${API_URL}${PREFIJO}/campanas/${campanaId}/slots`, { params, headers: authHeaders() });
  return res.data;
}
export async function reservarCita(campanaId, payload) {
  const res = await axios.post(`${API_URL}${PREFIJO}/campanas/${campanaId}/reservar`, payload, { headers: authHeaders() });
  return res.data;
}
export async function cancelarCita(citaId) {
  const res = await axios.post(`${API_URL}${PREFIJO}/citas/${citaId}/cancelar`, {}, { headers: authHeaders() });
  return res.data;
}

// --- Técnico (Fase 3c) ---

export async function getMisIntervenciones(params = {}) {
  const res = await axios.get(`${API_URL}${PREFIJO}/mis-intervenciones`, { params, headers: authHeaders() });
  return res.data;
}
export async function marcarCita(citaId, payload) {
  const res = await axios.post(`${API_URL}${PREFIJO}/citas/${citaId}/marcar`, payload, { headers: authHeaders() });
  return res.data;
}
// 3/11 · guardar las subtareas marcadas sin cerrar la cita (técnico de la cita o gestión).
export async function guardarProgresoCita(citaId, subtareasCompletadas) {
  const res = await axios.put(`${API_URL}${PREFIJO}/citas/${citaId}/subtareas`,
    { subtareas_completadas: subtareasCompletadas }, { headers: authHeaders() });
  return res.data;
}
// 3/11 · una cita realizada vuelve a reservada, con sus marcas (técnico de la cita o gestión).
export async function reabrirCita(citaId) {
  const res = await axios.post(`${API_URL}${PREFIJO}/citas/${citaId}/reabrir`, {}, { headers: authHeaders() });
  return res.data;
}
// 3/11 · B1 — cancelar una cita abierta (tipo 'usuario' | 'sistemas') o marcarla «no asistió»
// ('no_asistio'), desde el panel del técnico o el resumen (técnico de la cita o gestión). Motivo
// opcional, texto plano, hasta 500 caracteres.
export async function cancelarCitaGestion(citaId, tipo, motivo) {
  const res = await axios.post(`${API_URL}${PREFIJO}/citas/${citaId}/cancelacion`,
    { tipo, motivo: motivo || null }, { headers: authHeaders() });
  return res.data;
}
// Fase 25 · #25 — traspasar cita a otro técnico de la campaña.
export async function traspasarCita(citaId, payload) {
  const res = await axios.post(`${API_URL}${PREFIJO}/citas/${citaId}/traspasar`, payload, { headers: authHeaders() });
  return res.data;
}
export async function getMisBloqueos() {
  const res = await axios.get(`${API_URL}${PREFIJO}/mis-bloqueos`, { headers: authHeaders() });
  return res.data;
}

// --- Bloqueos por técnico/admin (Fase 12d) ---
// Devuelve los bloqueos YA expandidos por día: [{ id, fecha, hora_inicio, hora_fin, motivo }].
export async function getBloqueosTecnico(personaId, { desde, hasta } = {}) {
  const res = await axios.get(`${API_URL}${PREFIJO}/tecnico-bloqueos`, {
    params: { persona_id: personaId, desde, hasta },
    headers: authHeaders(),
  });
  return res.data.data || [];
}
export async function crearBloqueosBatch(bloqueos) {
  const res = await axios.post(`${API_URL}${PREFIJO}/tecnico-bloqueos/batch`, { bloqueos }, { headers: authHeaders() });
  return res.data;
}
export async function eliminarBloqueoTecnico(id) {
  const res = await axios.delete(`${API_URL}${PREFIJO}/tecnico-bloqueos/${id}`, { headers: authHeaders() });
  return res.data;
}

// --- Campañas técnico-scoped (Fase 12f) ---
// Namespace /tecnico/campanas (scope técnico vía campanas_tecnicos), distinto
// de /mis-campanas (scope usuario). Restricción por asignación en el backend.
export async function getTecnicoCampanas(params = {}) {
  const res = await axios.get(`${API_URL}${PREFIJO}/tecnico/campanas`, { params, headers: authHeaders() });
  return res.data.data || [];
}
export async function getTecnicoCampana(campanaId) {
  const res = await axios.get(`${API_URL}${PREFIJO}/tecnico/campanas/${campanaId}`, { headers: authHeaders() });
  return res.data.data;
}
export async function getTecnicoCampanaCalendario(campanaId, { desde, hasta } = {}) {
  const res = await axios.get(
    `${API_URL}${PREFIJO}/tecnico/campanas/${campanaId}/calendario`,
    { params: { desde, hasta }, headers: authHeaders() }
  );
  return res.data.data || [];
}
export async function crearBloqueo(payload) {
  const res = await axios.post(`${API_URL}${PREFIJO}/mis-bloqueos`, payload, { headers: authHeaders() });
  return res.data;
}
export async function editarBloqueo(id, payload) {
  const res = await axios.put(`${API_URL}${PREFIJO}/mis-bloqueos/${id}`, payload, { headers: authHeaders() });
  return res.data;
}
export async function borrarBloqueo(id) {
  const res = await axios.delete(`${API_URL}${PREFIJO}/mis-bloqueos/${id}`, { headers: authHeaders() });
  return res.data;
}

export default {
  getDashboard, getMiDisponibilidad,
  getCalendario, getResumenInformes, descargarCsvInformes,
  getMisNotificaciones, getNoLeidasCount, marcarNotifLeida, marcarTodasLeidas,
  getPreferenciasNotif, actualizarPreferenciasNotif,
  getPlantillasNotif, editarPlantillaNotif,
  getCampanas, getCampanaById, createCampana, updateCampana, deleteCampana,
  cambiarEstadoCampana, contarParticipacionesCanceladasSistema,
  previewCapacidad, previewImpacto,
  getResumenCampana, descargarCsvResumen, cancelarCitaAdmin, getCondicionesCita,
  getHistorialPersona,
  registrarIntervencion, deshacerIntervencion,
  getParticipantesTecnico, registrarIntervencionTecnico, deshacerIntervencionTecnico,
  getCandidatosIntervencion, getCandidatosTecnico,
  getLotes, previsualizarLote, crearLote, renombrarLote,
  anadirAlLote, quitarDelLote, moverEntreLotes,
  getPersonasElegibles, getNegocios, getDepartamentos, getEmpresasColaboradoras, getEmpresasContratantes,
  getMisCampanas, getMisCampanasPendientes, getMiCampana,
  getTecnicosDisponibles, getSlots, reservarCita, cancelarCita,
  getMisIntervenciones, marcarCita, traspasarCita,
  getMisBloqueos, crearBloqueo, editarBloqueo, borrarBloqueo,
  getBloqueosTecnico, crearBloqueosBatch, eliminarBloqueoTecnico,
  getTecnicoCampanas, getTecnicoCampana, getTecnicoCampanaCalendario,
};
